import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
`;

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(10px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
    padding: 1rem;
    opacity: ${props => props.isOpen ? 1 : 0};
    visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
    transition: all 0.3s ease;
`;

export const ModalContainer = styled.div`
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 25px;
    max-width: 500px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
    transform: ${props => props.isOpen ? 'scale(1)' : 'scale(0.9)'};
    transition: transform 0.3s ease;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
    padding: 2rem;

    @media (max-width: 480px) {
        padding: 1.5rem;
        border-radius: 20px;
    }
`;

export const ModalCloseButton = styled.button`
    position: absolute;
    top: 15px;
    right: 15px;
    background: rgba(255, 255, 255, 0.15);
    border: 2px solid rgba(255, 255, 255, 0.3);
    color: white;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
    font-size: 1.5rem;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    z-index: 10;
    line-height: 1;

    &:hover {
        background: rgba(255, 107, 139, 0.4);
        border-color: rgba(255, 107, 139, 0.6);
        transform: rotate(90deg) scale(1.1);
    }
`;

export const ModalHeader = styled.h2`
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0 0 1.5rem 0;
    background: linear-gradient(135deg, #ff6b8b, #6b5bff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-align: center;

    @media (max-width: 480px) {
        font-size: 1.5rem;
    }
`;

export const ProductSummary = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 15px;
    margin-bottom: 1.5rem;
    border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ProductThumb = styled.img`
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 12px;
    flex-shrink: 0;

    @media (max-width: 480px) {
        width: 60px;
        height: 60px;
    }
`;

export const ProductDetails = styled.div`
    flex: 1;

    h3 {
        font-size: 1.1rem;
        font-weight: 600;
        color: white;
        margin: 0 0 0.3rem 0;
        line-height: 1.3;

        @media (max-width: 480px) {
            font-size: 1rem;
        }
    }

    .price {
        font-size: 1.2rem;
        font-weight: 700;
        color: #4ecdc4;

        @media (max-width: 480px) {
            font-size: 1.1rem;
        }
    }
`;

export const ReservationForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
`;

export const FormRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
`;

export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.4rem;

    input {
        width: 100%;
        padding: 1rem 1.2rem;
        background: rgba(255, 255, 255, 0.1);
        border: 2px solid rgba(255, 255, 255, 0.1);
        border-radius: 12px;
        color: white;
        font-size: 1rem;
        transition: all 0.3s ease;
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        box-sizing: border-box;

        &::placeholder {
            color: rgba(255, 255, 255, 0.5);
        }

        &:focus {
            outline: none;
            border-color: #6b5bff;
            background: rgba(255, 255, 255, 0.15);
            box-shadow: 0 0 20px rgba(107, 91, 255, 0.3);
        }

        &:hover:not(:disabled) {
            border-color: rgba(255, 255, 255, 0.3);
        }

        &.error {
            border-color: #ff6b8b !important;
            box-shadow: 0 0 10px rgba(255, 107, 139, 0.3) !important;
        }

        &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }
    }
`;

export const InputLabel = styled.label`
    font-size: 0.9rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.8);
`;

export const Select = styled.select`
    width: 100%;
    padding: 1rem 1.2rem;
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    color: white;
    font-size: 1rem;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-sizing: border-box;
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23ffffff' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    padding-right: 2.5rem;

    &:focus {
        outline: none;
        border-color: #6b5bff;
        background-color: rgba(255, 255, 255, 0.15);
        box-shadow: 0 0 20px rgba(107, 91, 255, 0.3);
    }

    &:hover:not(:disabled) {
        border-color: rgba(255, 255, 255, 0.3);
    }

    &.error {
        border-color: #ff6b8b !important;
        box-shadow: 0 0 10px rgba(255, 107, 139, 0.3) !important;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        background-color: rgba(255, 255, 255, 0.05);
    }

    option {
        background: #1a1a2e;
        color: white;
        padding: 0.5rem;
    }
`;

export const ErrorMessage = styled.span`
    font-size: 0.85rem;
    color: #ff6b8b;
    animation: ${fadeIn} 0.3s ease;
`;

export const SubmitButton = styled.button`
    background: linear-gradient(135deg, #ff6b8b, #6b5bff);
    color: white;
    padding: 1rem 2rem;
    border: none;
    border-radius: 12px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    margin-top: 0.5rem;

    &:hover:not(:disabled) {
        transform: translateY(-3px);
        box-shadow: 0 15px 35px rgba(107, 91, 255, 0.4);
    }

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
        transform: none;
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
        transition: left 0.5s;
    }

    &:hover:not(:disabled)::before {
        left: 100%;
    }
`;

export const StatusMessage = styled.div`
    padding: 1rem;
    border-radius: 10px;
    text-align: center;
    font-size: 0.95rem;
    animation: ${fadeIn} 0.3s ease;

    ${props => props.type === 'error' && `
        background: rgba(255, 107, 139, 0.2);
        border: 1px solid rgba(255, 107, 139, 0.3);
        color: #ff6b8b;
    `}

    ${props => props.type === 'success' && `
        background: rgba(78, 205, 196, 0.2);
        border: 1px solid rgba(78, 205, 196, 0.3);
        color: #4ecdc4;
    `}
`;

export const SuccessContent = styled.div`
    text-align: center;
    padding: 1rem 0;

    h2 {
        font-size: 1.8rem;
        font-weight: 700;
        margin: 1rem 0;
        background: linear-gradient(135deg, #4ecdc4, #6b5bff);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }

    p {
        color: rgba(255, 255, 255, 0.8);
        margin: 0.5rem 0;
        font-size: 1rem;
    }

    strong {
        display: block;
        font-size: 1.2rem;
        color: white;
        margin: 0.5rem 0;
    }

    .price {
        font-size: 1.3rem;
        font-weight: 700;
        color: #4ecdc4;
        margin-bottom: 1rem;
    }

    button {
        margin-top: 1.5rem;
    }
`;

export const SuccessIcon = styled.div`
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4ecdc4, #6b5bff);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    font-size: 2.5rem;
    color: white;
    animation: ${fadeIn} 0.5s ease;
`;

export const CheckboxGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
`;

export const CheckboxLabel = styled.label`
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.85rem;
    line-height: 1.5;

    input[type="checkbox"] {
        width: 18px;
        height: 18px;
        min-width: 18px;
        margin-top: 2px;
        accent-color: #6b5bff;
        cursor: pointer;
        flex-shrink: 0;

        &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }
    }

    span {
        flex: 1;
    }

    a {
        color: #6b5bff;
        text-decoration: underline;
        transition: color 0.3s ease;

        &:hover {
            color: #ff6b8b;
        }
    }
`;

export const ShippingWarning = styled.div`
    background: rgba(255, 193, 7, 0.15);
    border: 1px solid rgba(255, 193, 7, 0.3);
    border-radius: 12px;
    padding: 1rem;
    color: #ffc107;
    font-size: 0.9rem;
    text-align: center;
    animation: ${fadeIn} 0.3s ease;

    &::before {
        content: '⚠️ ';
    }
`;
